import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import List from 'pages/offical/faq/components/list/main';
import React, { FC } from 'react';
import styles from './styles.scss';
import Button, { BaseBtnPros } from 'ac-components/ac-btn';

const FaqsSection: FC<{}> = (props) => {
	const { transData, t } = useTranslation('partner.faqs');

	return (
		<section className={styles['ac-faqs']} id="faqs">
			<div className={styles['ac-faqs-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title }} />
				{/* <div className={styles['desc']}>{transData.desc}</div> */}
				<div className={styles['ac-faqs-list']}>
					<List listData={transData.list} transData={transData} isHtml />
					<Button
						className={styles['button']}
						onClick={() => {
							window.open('https://ui.awin.com/merchant-profile/25266');
						}}>
						{transData.button}
					</Button>
				</div>
				{/* <h1>{transData.title2}</h1> */}
				<div className={styles['desc']}>
					<div
						dangerouslySetInnerHTML={{
							__html: t('partner.faqs.desc2', { img: 'https://web-data.zmlearn.com/image/w7CteKE8doGiadZKs3UAYX/img_p6_arrow%402x.png' }),
						}}
					/>
				</div>
			</div>
		</section>
	);
};

export default FaqsSection;
